import { render, staticRenderFns } from "./AvailabilitiesReminderMessage.vue?vue&type=template&id=02317c05&scoped=true&"
import script from "./AvailabilitiesReminderMessage.vue?vue&type=script&lang=js&"
export * from "./AvailabilitiesReminderMessage.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilitiesReminderMessage.vue?vue&type=style&index=0&id=02317c05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02317c05",
  null
  
)

export default component.exports